/**
 * Forbrukerrådet - Kommunetesten
 * @link https://gitlab01.copyleft.no/FBR/kommunetesten-new
 * @author Anders Evenrud <anders.evenrud@copyleft.no>
 */

import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Municipality from './views/Municipality.vue'
import Movement from './views/Movement.vue'
import NotFound from './views/NotFound.vue'
import { debounce } from 'lodash-es'

Vue.use(Router)

const redirYear = year => year === 'all' ? 2019 : year

const embedded = document.querySelector('#kommunetesten-new')
  .getAttribute('data-iframe') === 'true'

const pathname = embedded ? '/kommunetesten-iframe' : '/kommunetesten'

const sendAnalytics = debounce(() => {
  const pagename = pathname + window.location.hash.replace('#', '')

  if (window.ga) {
    window.ga('set', 'page', pagename)
    window.ga('send', 'pageview')
  }
}, 50)

const router = new Router({
  scrollBehavior () {
    return { x: 0, y: 0 }
  },

  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/county/:fid/moved',
      name: 'movement',
      component: Movement
    },
    {
      path: '/county/:fid',
      name: 'county',
      component: Home
    },
    {
      path: '/municipality/:kid',
      name: 'municipality',
      component: Municipality
    },

    // Redirect old links
    {
      path: '/year/:year',
      redirect: to => `/?year=${redirYear(to.params.year)}`
    },
    {
      path: '/kommune/:kid/year/:year',
      redirect: to => `/municipality/${to.params.kid}?year=${redirYear(to.params.year)}`
    },
    {
      path: '/fylke/:fid/year/:year',
      redirect: to => `/county/${to.params.fid}?year=${redirYear(to.params.year)}`
    },

    // Not Found
    {
      path: '*',
      component: NotFound
    }
  ]
})

router.afterEach(from => sendAnalytics(from))

export default router
